import React from "react";

import * as Styled from "./styles";
import { desqualifiedData } from "shared/data/fake";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { ISub } from "shared/types";

const DesqualifiedList: React.FC = () => {
  const [sub, setSub] = React.useState<ISub>({} as ISub);
  const [active, setActive] = React.useState<number>(0);

  const select = (index: number, sub: ISub) => {
    setActive(index);
    setSub(sub);
  };

  React.useEffect(() => {
    setSub(desqualifiedData[0].sub);
  }, []);

  return (
    <Styled.Container>
      <Table>
        <TableHead>
          <TableRow sx={{ width: "100%" }}>
            <TableCell>
              <Typography sx={{ fontWeight: "bold !important" }}>
                Nome/Razão Social
              </Typography>
            </TableCell>
            <TableCell>
              <Typography sx={{ fontWeight: "bold !important" }}>
                Nome Fantasia
              </Typography>
            </TableCell>

            <TableCell>
              <Typography sx={{ fontWeight: "bold !important" }}>
                Data descredenciamento
              </Typography>
            </TableCell>

            <TableCell>
              <Typography sx={{ fontWeight: "bold !important" }}>
                Tipo de prestador
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {desqualifiedData.map((item, index) => (
            <TableRow
              key={index}
              sx={{
                width: "100%",
                backgroundColor: index === active ? "grey.100" : "white",
              }}
              onClick={() => select(index, item.sub)}
            >
              <TableCell sx={{ cursor: "pointer" }}>{item.name}</TableCell>
              <TableCell sx={{ cursor: "pointer" }}>
                {item.fantasyName}
              </TableCell>
              <TableCell sx={{ cursor: "pointer" }}>
                {item.dateDesqualified}
              </TableCell>
              <TableCell sx={{ cursor: "pointer" }}>{item.type}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Typography variant="h5" sx={{ margin: "40px 0" }}>
        SUBSTITUTOS
      </Typography>

      <Table>
        <TableHead>
          <TableRow sx={{ width: "100%" }}>
            <TableCell>
              <Typography sx={{ fontWeight: "bold !important" }}>
                Nome/Razão Social
              </Typography>
            </TableCell>
            <TableCell>
              <Typography sx={{ fontWeight: "bold !important" }}>
                Nome Fantasia
              </Typography>
            </TableCell>

            <TableCell>
              <Typography sx={{ fontWeight: "bold !important" }}>
                Data descredenciamento
              </Typography>
            </TableCell>

            <TableCell>
              <Typography sx={{ fontWeight: "bold !important" }}>
                Tipo de prestador
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow
            sx={{
              width: "100%",
              backgroundColor: "white",
            }}
          >
            <TableCell>{sub.name}</TableCell>
            <TableCell>{sub.fantasyName}</TableCell>
            <TableCell>{sub.dateDesqualified}</TableCell>
            <TableCell>{sub.type}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Styled.Container>
  );
};

export { DesqualifiedList };
